<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'
	import type { FooterContext } from './link-structure.vue'
	import { cn } from '~/utils/functions'

	const { type = 'default' } = defineProps<{
		type?: 'default' | 'campaign'
		titleCls?: ClassNameValue
		liCls?: ClassNameValue
		btnCls?: ClassNameValue
		titleWrapperCls?: ClassNameValue
		openDefault?: string
	}>()
	const { Socials } = useStore()
	const { productLinks } = useProductsStore()
	const emits = defineEmits<{
		(event: 'login'): void
	}>()
	const isClaimsModal = shallowRef(false)
	const footerLinks = ref<FooterContext[]>([
		{
			title: 'Plans',
			open: true,
			links: productLinks,
			disabled: type === 'campaign'
		},
		{
			title: 'Quick Links',
			links: [
				{
					url: '/',
					label: 'Home'
				},
				{
					label: 'Claim',
					callback: () => {
						isClaimsModal.value = true
					}
				},
				{
					label: 'Login',
					callback: () => emits('login')
				}
			],
			open: false,
			disabled: type === 'campaign'
		},
		{
			title: 'Company',
			links: [
				{
					url: '/about-us',
					label: 'About Us'
				},
				{
					label: 'Product Guide',
					url: '/product-guide'
				},
				{
					label: 'Blog',
					url: '/blog'
				},
				{
					url: 'https://docs.mycover.ai/',
					label: 'API',
					target: '_blank'
				}
			],
			open: false,
			disabled: type === 'campaign'
		},
		{
			title: 'Legal',
			links: [
				{
					url: '/privacy-policy',
					label: 'Privacy Policy & Data Protection'
				},
				{
					url: '/cookie-policy',
					label: 'Cookies Policy'
				},
				{
					url: '/terms-and-conditions',
					label: 'Terms & Conditions'
				}
			],
			open: false,
			disabled: type === 'campaign'
		},
		{
			title: 'Contact Us',
			key: 'contact',
			links: [
				{
					url: 'tel:+234 9070008899',
					label: '+234 9070008899'
				},
				{
					url: 'mailto:hello@mycovergenius.com',
					label: 'hello@mycovergenius.com'
				},
				{
					label: '8 The Providence Street, Lekki Phase 1, Lagos, Nigeria'
				}
			],
			open: false
		},
		{
			title: 'Socials',
			displayOnlyOnMobile: true,
			links: Socials,
			open: false,
			disabled: type === 'campaign'
		}
	])
	const cls = String(useAttrs().class ?? '')
</script>

<template>
	<div :class="cn('w-full mx-auto sm:rounded-[30px] rounded-2xl bg-gray-800 mt-16 sm:p-16 p-8', cls)">
		<footer-link-structure
			:link-list="footerLinks"
			:key-id="openDefault"
			:title-wrapper-cls
			:titleCls
			:liCls
			:btnCls
		/>
		<molecules-claims-dialog v-if="type === 'default'" v-model="isClaimsModal" />
	</div>
</template>
